// Shared chart palette — iOS-style saturated colors that pop on frosted glass cards.
export const PALETTE = [
  "#FF3B30", // red
  "#FF9500", // orange
  "#FFCC00", // yellow
  "#34C759", // green
  "#00C7BE", // teal
  "#30B0C7", // cyan
  "#007AFF", // blue
  "#5856D6", // indigo
  "#AF52DE", // purple
  "#FF2D55", // pink
  "#A2845E", // brown
  "#32ADE6", // light blue
];

export const color = (i) => PALETTE[i % PALETTE.length];

export const tooltipStyle = {
  backgroundColor: "rgba(255,255,255,0.85)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  border: "1px solid rgba(255,255,255,0.7)",
  borderRadius: 14,
  boxShadow: "0 8px 30px rgba(17,24,39,0.12)",
  padding: "8px 12px",
  fontFamily: "Inter, system-ui, sans-serif",
  fontSize: 12,
};

export const legendStyle = {
  fontSize: 10,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
};
